import { useAppContext } from "../context/appContext";

const Loading = () => {
  const { isLoading } = useAppContext();
  if (isLoading) return <div className="loading"></div>;
};

export default Loading;
